import { RefObject } from 'react';

import { dateService } from 'shared/lib/date';

import { Time } from '../../constants';

type DateParam = Date | number | null | undefined;

export const getMinDate = (startDate: DateParam) => {
  const date = startDate ? startDate.valueOf() : Date.now();
  return dateService.getStartOfDayDateObject(date);
};

export const getMaxDate = (minDateValue: Date) => {
  return dateService.getEndOfDayDateObject(
    dateService.getDayJSObject(minDateValue).add(1, 'y').toDate(),
  );
};

export const getTimeFromDate = (date: DateParam): Time | null => {
  if (!date || (typeof date !== 'number' && !(date instanceof Date))) {
    return null;
  }

  date = typeof date === 'number' ? new Date(date) : date;
  const [hours, minutes, seconds] = [
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
  ];

  return { hours, minutes, seconds };
};

export const setDateInputPosition = (
  dateInputRef: RefObject<HTMLDivElement>,
  radioRef: RefObject<HTMLDivElement>,
) => {
  if (dateInputRef.current && radioRef.current) {
    const { top } = radioRef.current.getBoundingClientRect();
    dateInputRef.current.style.top = top - 8 + 'px';
    dateInputRef.current.style.left =
      radioRef.current.offsetLeft + radioRef.current.offsetWidth + 'px';
  }
};
